import { Suspense, lazy, useEffect } from 'react';
import { net, useApp } from './net';
import { Auth } from './core/Auth';
import { Lobby } from './core/Lobby';

/**
 * The battle screen pulls in the whole Pokedex (~480KB gzipped), which nobody
 * on a phone should download just to look at the lobby. Loading it on demand
 * keeps the first paint small; by the time a challenge is accepted it is
 * already warm.
 */
const BattleView = lazy(async () => ({
  default: (await import('./games/pokemon/BattleView')).BattleView,
}));

export function App() {
  const app = useApp();

  useEffect(() => {
    if (net.token) net.connect();
  }, []);

  // Warm the battle bundle once signed in, so accepting a challenge is instant.
  useEffect(() => {
    if (app.user) void import('./games/pokemon/BattleView');
  }, [app.user]);

  if (!net.token) return <Auth />;

  const room = app.activeRoom ? app.joined[app.activeRoom] : undefined;
  if (room) {
    return (
      <Suspense fallback={<div className="loading">Loading battle…</div>}>
        {/* Keyed on the room so switching battles starts clean client state. */}
        <BattleView key={room.summary.id} view={room} />
      </Suspense>
    );
  }

  return <Lobby />;
}
